import React, { useContext, useEffect } from 'react';
import Modal from 'react-modal';
import ReactTooltip from 'react-tooltip';

import { DataContext } from '../../context/DataContext';
import { FaInfoCircle } from 'react-icons/fa';
import { beneficiarioDefault } from '../../data/data';
import { parentescos } from '../../data/mochaData';
import { importate, restriccion } from '../../data/texts';
import { ImgAlert } from '../../svg';
import { customStyles } from '../../utils/constanst';
import { getUUID } from '../../utils/helpers';

import DivRow from '../controls/DivRow';

import Input from '../controls/Input';
import InputSelect from '../controls/InputSelect';


const Step4 = () => {

    const { poliza, setPoliza, changeHandler } = useContext(DataContext);
    const toolTipText = "<div class='tooltip-line'></div><p class='tooltip-text'>Indicar el nombre de la persona que<br>representará al menor de edad en la<br>indemnización del seguro</p>";
    useEffect(() => {
        ReactTooltip.rebuild();

    }, [0]);


    const addBene = () => {
        setPoliza({ ...poliza, beneficiarios: [...poliza.beneficiarios, { ...beneficiarioDefault, key: getUUID() }] });
    }

    const handleClick = (beneficiario, e) => {

        const { key } = beneficiario;
       /// let xparentesco = '';

        // if (e.target.name = 'parentesco' && e.target.selectedIndex >= 0) {
        //     xparentesco = e.target.options[e.target.selectedIndex].text;
        // }

        setPoliza({
            ...poliza,
            beneficiarios: [
                ...poliza.beneficiarios.filter(x => x.key != key),
                {
                    ...beneficiario,
                    [e.target.name]: e.target.value
                    //xparentesco: xparentesco == '' ? beneficiario.xparentesco : xparentesco
                }
            ]
        })

    }

    const deleteBene = (beneficiario) => {

        const { key } = beneficiario;

        setPoliza({
            ...poliza,
            beneficiarios: [
                ...poliza.beneficiarios.filter(x => x.key != key)
            ]
        });

    }


    const sortArr = (a, b) => a.key > b.key ? 1 : -1;

    const closeModal = () => setPoliza({ ...poliza, showDialogBeneficiaries: false });

    return (
        <>
        <div>
            <div className="reponsive">
                <div className='reponsive-width-12'>
                    <p className="step-title">¿Cuántos beneficiarios desea agregar? Si deseas agregar otros beneficiarios marca en el signo +</p>
                </div>
            </div>           
            {
                poliza.beneficiarios.sort(sortArr).map((beneficiario, index) => {

                    const { nombres, parentesco, porcentaje } = beneficiario;

                    return  <div className="reponsive" key={index}>                                
                                <div className='reponsive-width-5'>
                                    <div className='box-pl2-pr2'>
                                        <Input value={nombres} field='nombres' placeholder='Nombres completo' onChange={e => handleClick(beneficiario, e)} />
                                    </div>
                                </div>
                                <div className='reponsive-width-3'>
                                    <div className='box-pl2-pr2'>
                                        <InputSelect containBlank={true} placeholder='Seleccione...' label='' field='parentesco' value={parentesco} dataProvider={parentescos} onChange={e => handleClick(beneficiario, e)} />
                                    </div>
                                </div>
                                <div className='reponsive-width-4'>
                                    <div className='box-pl2-pr2'>
                                        <Input type='number' value={porcentaje} field='porcentaje' onChange={e => handleClick(beneficiario, e)} placeholder='0%' classNameInput='w100' />
                                    </div>
                                </div>
                                <div className='reponsive-width-1 step-container-pt-15'>
                                    <button className="btn-delete" onClick={() => deleteBene(beneficiario)}>-</button>
                                </div>
                                
                            </div>
                })
            }
            <div className="reponsive">
                <div className='reponsive-width-12'>
                    <p className="step-title">La suma de los porcentajes debe ser igual al 100%</p>
                </div>
            </div>  

            <div className="reponsive">
                <div className='reponsive-width-12'>
                    <div className='box-pl2-pr2 step-container-pt-15'>
                        <button onClick={addBene} className="control-button-btn btn-sg-primary">+</button>
                    </div>
                </div>
                
            </div>

            <div className="reponsive">
                <div className='reponsive-width-12'>
                    <p className="step-title"><b>Importante:</b> {importate}</p>
                </div>
            </div>

            <div className="reponsive">
                <div className='reponsive-width-6'>
                    <div className='box-pl2-pr2'>
                        <Input info={toolTipText} 
                        required={false} 
                        label='Nombre del representante'
                         field='nombreRepresentante' 
                         value={poliza.nombreRepresentante} 
                         onChange={changeHandler}
                         usetooltip = "true"
          
                         >
                        
                        </Input>
                    </div>
                </div>
                <div className='reponsive-width-6'>
                    <div className='box-pl2-pr2'>
                        <Input required={false} label='Número de cédula' field='cedulaRepresentante' value={poliza.cedulaRepresentante} onChange={changeHandler} >
                        
                        </Input>
                    </div>
                </div>
            </div>

            <div className="reponsive">
                <div width='reponsive-width-12'>
                    <p className="step-title"></p>
                </div>
            </div>
            <Modal
                isOpen={poliza.showDialogBeneficiaries}
                onRequestClose={closeModal}
                style={customStyles}
                shouldCloseOnOverlayClick={false}
                contentLabel="Example Modal"
            >
                <div className="dialog-center-content">
                    <ImgAlert />
                </div>
                <h3 className="txt-primary">Debe completar el 100% de participación para los beneficiarios</h3>
                <div className="dialog-center-content">
                    <button type="button" className="control-button-btn btn-color-primary" onClick={closeModal}>Entendido</button>
                </div>
            </Modal>
        </div>
        <ReactTooltip className='tooltip-os' />
        </>
    );
}

export default Step4;
